module.exports = __webpack_public_path__ + "static/media/history_23.face524c.jpg";